import React ,{useState,useEffect} from 'react'
import {TiArrowUpOutline} from 'react-icons/ti'

const BackToTop = () => {
    const[top,setTop] = useState(false);

    useEffect(()=>{
        window.addEventListener("scroll",()=>{
            if(window.scrollY>100){
                setTop(true)
            } else {
                setTop(false)
            }
        })
    },[])

    const scrollup = () =>{
        window.scrollTo({
            top:0,
            behavior:'smooth'
        })
    }
  return (
    <div>
      {top && (
        <button style={{position:"fixed",bottom:"50px",right:"50px",height:"50px",fontSize:"50px"}} onClick={scrollup}><TiArrowUpOutline /></button>
      )}
    </div>
  )
}

export default BackToTop
